import React, { useState } from "react";
import { X, MessageCircle } from "lucide-react";

const WHATSAPP_NUMBER = "5588988676142";
const WHATSAPP_MSG = encodeURIComponent("Olá! Preciso de suporte do UniPlay HD.");
const WA_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MSG}`;

export default function SupportNotice() {
  const [open, setOpen] = useState(true);
  if (!open) return null;

  return (
    <div className="fixed bottom-24 left-4 md:bottom-28 md:left-6 z-40 w-[300px] max-w-[88vw] rounded-2xl bg-[#1a1414] border border-red-600/40 shadow-2xl overflow-hidden">
      <div className="flex items-start gap-3 p-4">
        <div className="glow-ring w-10 h-10 shrink-0">
          <img src="https://img.freepik.com/fotos-premium/stylist-de-cabelo-avatar-digital-inteligencia-artificial-gerativa_934475-9013.jpg" alt="Suporte" className="w-full h-full rounded-full object-cover" />
        </div>
        <div className="flex-1">
          <p className="text-red-500 font-bold text-xs uppercase tracking-wider">Aviso de Suporte</p>
          <p className="text-white/85 text-xs mt-1.5 leading-relaxed">
            Precisa de ajuda? Fale direto com nossa equipe pelo WhatsApp. Atendemos cadastros, ativações de aplicativos e dúvidas sobre canais.
          </p>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#25D366] text-white text-xs font-bold shadow-md hover:brightness-110 transition"
          >
            <MessageCircle className="w-3.5 h-3.5" /> Falar no WhatsApp
          </a>
        </div>
        <button onClick={() => setOpen(false)} className="w-6 h-6 rounded-full bg-black/40 hover:bg-black/70 flex items-center justify-center shrink-0">
          <X className="w-3 h-3 text-white" />
        </button>
      </div>
    </div>
  );
}
